/* Scratch-card email popup, used by sections/bw-scratch-popup.liquid. */
(function () {
  if (!window.customElements || customElements.get('bw-scratch-popup')) return;
  var STORE = 'bw-scratch-popup';

  function read() {
    try { return JSON.parse(localStorage.getItem(STORE)) || {}; } catch (e) { return {}; }
  }
  function write(v) {
    try { localStorage.setItem(STORE, JSON.stringify(v)); } catch (e) {}
  }

  class BwScratchPopup extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.querySelector('[data-next]').addEventListener('click', () => this.step('email'));
      this.querySelector('form').addEventListener('submit', (e) => this.submit(e));
      this.onKey = (e) => { if (e.key === 'Escape' && !this.hidden) this.close(); };
      document.addEventListener('keydown', this.onKey);

      var shop = this.querySelector('[data-shop]');
      if (shop && this.dataset.code) {
        shop.href = '/discount/' + encodeURIComponent(this.dataset.code) + '?redirect=' + encodeURIComponent(location.pathname);
      }

      var section = this.closest('.shopify-section');
      document.addEventListener('shopify:section:select', (e) => { if (section && e.target === section) this.open(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (section && e.target === section) this.hide(); });

      var state = read();
      var days = Number(this.dataset.days) || 0;
      var snoozed = state.closed && Date.now() - state.closed < days * 864e5;
      if (/[?&]popup-preview=1/.test(location.search)) {
        setTimeout(() => this.open(), 800);
      } else if (this.dataset.auto === 'true' && !state.subscribed && !snoozed && !window.Shopify?.designMode) {
        setTimeout(() => this.open(), (Number(this.dataset.delay) || 12) * 1000);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    open() {
      if (!this.hidden) return;
      this.hidden = false;
      requestAnimationFrame(() => this.paintFoil());
    }

    hide() {
      this.hidden = true;
    }

    close() {
      var state = read();
      state.closed = Date.now();
      write(state);
      this.hide();
    }

    step(name) {
      this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== name; });
      if (name === 'email') this.querySelector('input').focus();
    }

    paintFoil() {
      var canvas = this.querySelector('.bw-sp__foil');
      if (!canvas || canvas.dataset.painted) return;
      var box = canvas.getBoundingClientRect();
      if (!box.width) return;
      var ratio = window.devicePixelRatio || 1;
      canvas.width = box.width * ratio;
      canvas.height = box.height * ratio;
      var ctx = canvas.getContext('2d');
      ctx.scale(ratio, ratio);
      var g = ctx.createLinearGradient(0, 0, box.width, box.height);
      g.addColorStop(0, '#c99a3c');
      g.addColorStop(0.3, '#f3d98b');
      g.addColorStop(0.55, '#d1a64a');
      g.addColorStop(0.8, '#f0d27e');
      g.addColorStop(1, '#b8892f');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, box.width, box.height);
      // Crinkled foil: light and dark specks over the gradient.
      for (var i = 0; i < 2600; i++) {
        var light = Math.random() > 0.5;
        ctx.fillStyle = light ? 'rgba(255,248,220,' + (Math.random() * 0.35) + ')' : 'rgba(120,85,20,' + (Math.random() * 0.18) + ')';
        ctx.fillRect(Math.random() * box.width, Math.random() * box.height, 1 + Math.random() * 2, 1 + Math.random() * 2);
      }
      var sheen = ctx.createRadialGradient(box.width * 0.35, box.height * 0.2, 0, box.width * 0.35, box.height * 0.2, box.width * 0.7);
      sheen.addColorStop(0, 'rgba(255,250,225,0.45)');
      sheen.addColorStop(1, 'rgba(255,250,225,0)');
      ctx.fillStyle = sheen;
      ctx.fillRect(0, 0, box.width, box.height);
      ctx.fillStyle = 'rgba(110,80,25,0.22)';
      for (var s = 0; s < 4; s++) {
        ctx.save();
        ctx.translate(box.width * (0.3 + s * 0.12), box.height * 0.5);
        ctx.rotate(-0.35);
        ctx.fillRect(-14, -box.height * 0.28, 28, box.height * 0.56);
        ctx.restore();
      }
      ctx.fillStyle = 'rgba(255,250,235,0.8)';
      ctx.font = '800 ' + Math.round(box.width / 9) + 'px ' + getComputedStyle(this).fontFamily;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH HERE', box.width / 2, box.height / 2);
      canvas.dataset.painted = 'true';
      this.bindScratch(canvas, ctx, box);
    }

    bindScratch(canvas, ctx, box) {
      var last = null;
      var distance = 0;
      var strokes = 0;
      var point = (e) => {
        var r = canvas.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      };
      // Solid trails between pointer positions, so fast swipes leave no gaps.
      var scratch = (p) => {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 64;
        ctx.beginPath();
        ctx.moveTo(last ? last.x : p.x, last ? last.y : p.y);
        ctx.lineTo(p.x + 0.01, p.y);
        ctx.stroke();
        if (last) distance += Math.hypot(p.x - last.x, p.y - last.y);
        last = p;
        // A few strokes are enough: reveal after about 1.5 card widths of scratching.
        if (distance > box.width * 1.5) this.reveal(canvas);
      };
      canvas.addEventListener('pointerdown', (e) => { strokes++; last = null; canvas.setPointerCapture(e.pointerId); scratch(point(e)); });
      canvas.addEventListener('pointermove', (e) => { if (last) scratch(point(e)); });
      canvas.addEventListener('pointerup', () => {
        last = null;
        if (strokes >= 3) this.reveal(canvas);
        else this.checkCleared(canvas, ctx);
      });
      canvas.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') this.reveal(canvas); });
      canvas.tabIndex = 0;
    }

    checkCleared(canvas, ctx) {
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var clear = 0, total = 0;
      for (var i = 3; i < data.length; i += 64) { total++; if (data[i] === 0) clear++; }
      if (clear / total > 0.25) this.reveal(canvas);
    }

    reveal(canvas) {
      if (canvas.classList.contains('is-gone')) return;
      canvas.classList.add('is-gone');
      this.querySelector('[data-next]').hidden = false;
    }

    async submit(e) {
      e.preventDefault();
      var form = e.target;
      var input = form.querySelector('input');
      var error = form.querySelector('.bw-sp__error');
      var email = input.value.trim();
      error.hidden = true;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        error.textContent = 'Enter a valid email address.';
        error.hidden = false;
        return;
      }
      if (!this.dataset.key || !this.dataset.list) {
        error.textContent = 'Sign-up isn\'t connected yet. Add the Klaviyo key and list ID in the theme editor.';
        error.hidden = false;
        return;
      }
      var button = form.querySelector('button');
      button.disabled = true;
      try {
        var res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.dataset.key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Scratch popup',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.list } } }
            }
          })
        });
        if (!res.ok) throw new Error(res.status);
        var state = read();
        state.subscribed = Date.now();
        write(state);
        this.step('done');
      } catch (err) {
        error.textContent = 'Something went wrong. Please try again.';
        error.hidden = false;
      } finally {
        button.disabled = false;
      }
    }
  }

  customElements.define('bw-scratch-popup', BwScratchPopup);
})();